




















































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';
import {
  minLenght,
  hasAtLeastNumber,
  hasAtLeastLetter
} from '@/utils/validationPassword';
import { Faker } from '@/utils/faker';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import RulePassword from '@/componentsV2/molecules/RulePassword/RulePassword.vue';
import flagKeys from '../../../../constants/flagKeys';
import recaptchaRoutesKeys from '@/constants/recaptchaRoutesKeys';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';
import eventBus from '@/utils/eventBus';

export type AccountFormData = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  recaptcha?: string;
};

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FilledButton,
    Input,
    RulePassword
  }
})
export default class AccountForm extends Vue {
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: () => ({}) }) defaultFormData?: Partial<AccountFormData>;
  @Prop({ default: 'Next' }) labelBtnSubmit?: string;
  @Prop({ default: true }) showBackButton?: boolean;
  @Prop({ default: true }) showFooter?: boolean;

  failedRulesPassword: string[] = [];

  form: AccountFormData = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    ...(this.defaultFormData && this.defaultFormData)
  };

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  clearFailedRulesPassword() {
    if (this.flagRulesPassword && this.$refs.observer) {
      this.failedRulesPassword = [];
    }

    this.$emit('changeUserDataPassword', this.form);

    return;
  }

  get isPasswordLengthValid() {
    return minLenght(this.form.password);
  }

  get isPasswordNumberValid() {
    return hasAtLeastNumber(this.form.password);
  }

  get isPasswordLetterValid() {
    return hasAtLeastLetter(this.form.password);
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get flagRulesPassword() {
    return this.flags.includes(flagKeys.enableRulesPassword);
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (this.flagRulesPassword) {
      if (
        !this.isPasswordLengthValid ||
        !this.isPasswordNumberValid ||
        !this.isPasswordLetterValid
      ) {
        const failedRules = formRef.fields.password.failedRules;
        this.failedRulesPassword = Object.keys(failedRules);
        return null;
      }
    }

    if (!formIsValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');

      return;
    }

    if (this.flags.includes(flagKeys.businessSignupCaptcha)) {
      this.form.recaptcha = await this.$recaptcha(
        recaptchaRoutesKeys.businessSignup
      );
    }
    if (formRef) formRef.reset();
    this.$emit('submit', this.form);
  }

  handleTestData() {
    const firstName = Faker.firstName();
    const lastName = Faker.lastName();
    const email = Faker.email(`${firstName}.${lastName}`.toLowerCase());

    this.form = {
      ...this.form,
      firstName,
      lastName,
      email,
      password: Faker.password()
    };
  }

  created() {
    eventBus.$on('accountFormSubmit', this.onSubmit);
  }

  beforeDestroy() {
    eventBus.$off('accountFormSubmit', this.onSubmit);
  }
}
